import gql from 'graphql-tag';

export const INSPECTION_SCOPE_ITEM_FIELDS = gql`
  fragment InspectionScopeItemFields on InspectionScopeItemType {
    id # ID!
    budget # Float
    clientDisbursement # Float
    createdAt # UnixTimestamp
    description # String
    disbursement # Float
    name # String
    orderUnit { # OrderUnitType
      id
      name
    }
    orderUnitId # String
    previousDisbursement # Float
    progress # Float
    previousInspectionScopeItem { # InspectionScopeItemType
      id
      budget
      clientDisbursement
      createdAt
      description
      disbursement
      name
      orderUnitId
      previousDisbursement
      tags
      updatedAt
    }
    tags # JsonAsString
    updatedAt # UnixTimestamp
  }
`;
